// extracted by mini-css-extract-plugin
module.exports = {"ninety":"footer_ninety__yDrdC","heading":"footer_heading__qp5Kw","social":"footer_social__cRo4D"};